export function resolveApiAssetUrl(
  apiServer: string,
  path?: string | null,
): string {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;

  const base = apiServer.replace(/\/$/, '');
  const assetPath = path.replace(/^\//, '');
  return `${base}/${assetPath}`;
}
